export default __webpack_public_path__ + "static/media/DSC04821.2ad60a6f.jpg";